<script setup>
import Input from 'next/input/Input.vue';

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  messageType: {
    type: String,
    default: 'info',
  },
  message: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['blur', 'update:modelValue']);

const model = defineModel({
  type: String,
  default: '',
});

const onInput = ev => {
  const formattedValue = ev.target.value
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '_');
  emit('update:modelValue', formattedValue);
};
</script>

<template>
  <Input
    v-model="model"
    :label="label"
    :disabled="disabled"
    :message-type="messageType"
    :message="message"
    type="text"
    @input="onInput"
    @blur="emit('blur')"
  />
</template>
